import { ContractType, useGetContractsV2Query } from '../types';
import { findActiveContract, sortContracts } from '../utils/contract-utils';

export interface ActiveContractPartnershipResult {
  /** Undefined while loading, on error, or when no active contract exists. */
  partnershipId: number | undefined;
  loading: boolean;
}

// Enough to cover any real client insurer's contract history in one page,
// so the active one can't be paged out of the result.
const CONTRACTS_PAGE_SIZE = 100;

/**
 * The partnership on a client insurer's most recent active contract.
 *
 * `sortContracts` defaults to newest start date first, so the first active
 * contract it finds is the most recent one. Voided contracts are excluded at
 * the query rather than relied on to fail the active check.
 */
export const useActiveContractPartnership = (
  clientInsurerId: number,
): ActiveContractPartnershipResult => {
  const { data, loading } = useGetContractsV2Query({
    variables: {
      clientsInsurerIds: [clientInsurerId],
      includeVoided: false,
      page: 1,
      size: CONTRACTS_PAGE_SIZE,
    },
  });

  const contracts = (data?.getContractsV2?.items ?? []) as ContractType[];
  const activeContract = findActiveContract(sortContracts(contracts));

  return {
    partnershipId: activeContract?.partnershipId ?? undefined,
    loading,
  };
};
